import React from 'react'
import './public-events-page.css'

function PublicEventsPage() {
  return (
    <div>PublicEventsPage</div>
  )
}

export default PublicEventsPage